// extracted by mini-css-extract-plugin
export var banner = "styles-module--banner--84cba";
export var close = "styles-module--close--a8965";